module.exports = __webpack_public_path__ + "static/img/success.5fb378d2.png";